import { render } from "./Players.vue?vue&type=template&id=5e2788be&scoped=true"
import script from "./Players.vue?vue&type=script&lang=ts"
export * from "./Players.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-5e2788be"

export default script